import {Select} from 'antd';

export const SongSelector = ({songs, selectedSong, onChange}) => {
    const options = [
        {
            label: 'No Song',
            value: null
        },
        ...songs.map(song => ({
            label: song.song_name,
            value: song.id
        }))
    ];

    const selectedValue = selectedSong?.id || null;
    const selectedOption = options.find(opt => opt.value === selectedValue);

    return (
        <Select
            style={{ width: '100%' }}
            placeholder="Select a song"
            value={selectedValue}
            onChange={onChange}
            options={options}
            allowClear
            labelInValue={false}
        />
    );
};
